// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* .lb-table .el-table .el-table__body-wrapper .el-table__body .el-table__row .el-table__cell .cell{\n  padding: 0 !important;\n} */\n", ""]);
// Exports
module.exports = exports;
